import { T } from '../../styles/tokens';
/** Skills Center shared styles */

export const scStyles = {
  glass: {
    backdropFilter: 'blur(16px)',
    background: T.bgOverlay,
    border: `1px solid ${T.purpleBgStrong}`,
    borderRadius: '16px',
  } as Record<string, string>,

  gradientPurple: {
    background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
  } as Record<string, string>,

  cardHover: {
    transform: 'scale(1.02)',
    boxShadow: `0 8px 32px ${T.purpleBgStrong}`,
  } as Record<string, string>,

  badgeVerified: {
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700,
    background: T.successBg, color: T.success,
    border: `1px solid ${T.successBgStrong}`,
  } as Record<string, any>,

  badgeRecommended: {
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700,
    background: T.warningBg, color: T.warning,
    border: `1px solid ${T.warningBgStrong}`,
  } as Record<string, any>,

  badgeCommunity: {
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700,
    background: T.primaryBg, color: T.primary,
    border: `1px solid ${T.primaryBgStrong}`,
  } as Record<string, any>,

  badgeNew: {
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 700,
    background: 'rgba(236, 72, 153, 0.15)', color: '#EC4899',
    border: '1px solid rgba(236, 72, 153, 0.3)',
    animation: 'badgePulse 2s ease-in-out infinite',
  } as Record<string, any>,
};

export const scKeyframes = `
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes slideIn {
  from { opacity: 0; transform: translateX(100%); }
  to { opacity: 1; transform: translateX(0); }
}
@keyframes slideOut {
  from { opacity: 1; transform: translateX(0); }
  to { opacity: 0; transform: translateX(100%); }
}
@keyframes badgePulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
@keyframes countUp {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes skeletonShimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
`;
